export const defaultViewerConfig = {
  "title": "new application",
  "subtitle": "version 0.1",
  "mainArea": {
    "widget": "SplitLayout",
    "areas": [],
    "areaSizes": ["0", "1"],
    "direction": "column"
  },
  "bbsparqlendpoint":"repo=Demo",
  "repoURL": "/servlets/cgi/sparql/Demo",
  "logoURL": "/logos/logo-wistor.png",
  "sparqlErrorMessage": "\"errors connecting to the server\"",
  "css": "{\"height\":\"100%\"}",
  "pageWidth": "99%",
  "parameterValues": "{\"imgeo\":\"http://www.buildingbits.nl/coins2/draft/IMGEO.rdf\",\"cb23\":\"http://rotterdam.nl/data/CB23\"}",
  "public": true,
  "strictSparqlErrors": true,
  "notifySparqlErrors": true
} as const
